type Params = {
  module?: '' | 'leads' | 'deals';
  recordId?: string;
};
const getPredefinedPrompts = (params: Params) => {
  // leads
  if (params?.module === 'leads') {
    if (params?.recordId) {
      return [
        'Summarize this lead.',
        'Suggest an email follow-up for this lead.',
        'Summarize Notes for this lead.',
        'Summarize Activity for this lead.',
        'What are my upcoming tasks for this lead?',
      ];
    } else {
      return [
        'Which leads are most likely to convert?',
        'Who are my hottest leads right now?',
        'Give me my top 10 best performing leads?',
        'What’s my team’s conversion rate this week?',
      ];
    }
  }
  // deals
  else if (params?.module === 'deals') {
    if (params?.recordId) {
      return [
        'Summarize this Deal',
        'Suggest an email follow-up for this deal.',
        'Summarize Notes for this deal.',
        'Summarize Activity for this deal.',
        'What are my upcoming tasks for this deal?',
      ];
    } else {
      return [
        'Which deals are most likely to close this week?',
        'Show me all deals currently in the negotiation stage.',
        'Which deals have been stalled for a few days?',
        'How does our win rate compare to last week?',
        'What’s the total value of deals expected to close this week?',
      ];
    }
  } else {
    return [];
  }
};

export default getPredefinedPrompts;
